import { FaCalculator, FaRegCommentDots } from 'react-icons/fa';
import { GiElectric, GiSolarPower, GiWaterDrop, GiHeatHaze } from 'react-icons/gi';
import { useAppContext } from '../context/appContext';
import { useState } from 'react';
import Wrapper from "../assets/wrappers/Job"
import InformationItemInfo from "./InformationItemInfo"
import InformationItemEditInput from './InformationItemEditInput';
import calculations from '../utils/calculations';

const initialLocalState = {
    isEditing: false,
}

const InformationItem = ({
    currentInformationItem, previousInformationItem,
}) => {
    const { editInformationItem /*, deleteInformationItem */} = useAppContext();

    const [localStateValues, setLocalStateValues] = useState(initialLocalState);

    const { isEditing } = localStateValues;

    const monthsShort = 'Jan_Feb_März_Apr_Mai_Juni_Juli_Aug_Sep_Okt_Nov_Dez'.split('_');

    const {
        isPreviousMonthProvided,
        consumptionElectricity,
        gainPhotovoltaic,
        consumptionWater,
        consumptionHeating
    } = calculations.calculateConsumption(currentInformationItem, previousInformationItem ? previousInformationItem : null);

    const onSubmit = (e) => {
        e.preventDefault();
        try {
            var newElectricity = document.getElementById(`${currentInformationItem._id}electricity`).value;
            var newCommentElectricity = document.getElementById(`${currentInformationItem._id}commentElectricity`).value;
            var newPhotovoltaic = document.getElementById(`${currentInformationItem._id}photovoltaic`).value;
            var newCommentPhotovoltaic = document.getElementById(`${currentInformationItem._id}commentPhotovoltaic`).value;
            var newWater = document.getElementById(`${currentInformationItem._id}water`).value;
            var newCommentWater = document.getElementById(`${currentInformationItem._id}commentWater`).value;
            var newHeating = document.getElementById(`${currentInformationItem._id}heating`).value;
            var newCommentHeating = document.getElementById(`${currentInformationItem._id}commentHeating`).value;

            editInformationItem(
                currentInformationItem.id,
                newElectricity,
                newCommentElectricity,
                newPhotovoltaic,
                newCommentPhotovoltaic,
                newWater,
                newCommentWater,
                newHeating,
                newCommentHeating);

            setLocalStateValues({ isEditing: false });
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <Wrapper>
            <header>
                <div className="main-icon">{monthsShort[currentInformationItem.month - 1]}</div>
                <div className='info'>
                    <h5>{currentInformationItem.year} - {String(currentInformationItem.month).padStart(2, '0')}</h5>
                    {isPreviousMonthProvided ?
                        <p style={{ color: "green", textTransform: "initial" }}>Vorheriger Monat vorhanden</p>
                        :
                        <p style={{ color: "red", textTransform: "initial" }}>Kein vorheriger Monat gefunden</p>
                    }
                </div>
            </header>
            {isEditing ?
                <form onSubmit={onSubmit}>
                    <div className='content'>
                        <div className='content-comment'>
                            <InformationItemInfo text={"Strom:"} headline />
                        </div>
                        <div className='content-center'>
                            <InformationItemEditInput
                                icon={<GiElectric />}
                                type={"float"}
                                id={`${currentInformationItem._id}electricity`}
                                unit={"kWh"}
                                value={currentInformationItem.electricity}
                                placeholder={"Zählerstand Strom"}
                            />
                            <InformationItemEditInput
                                icon={<FaRegCommentDots />}
                                type={"text"}
                                maxLength={99}
                                id={`${currentInformationItem._id}commentElectricity`}
                                value={currentInformationItem.commentElectricity}
                                placeholder={"Kommentar Strom"}
                            />
                        </div>
                        <div className='content-comment'>
                            <InformationItemInfo text={"Photovoltaik:"} headline />
                        </div>
                        <div className='content-center'>
                            <InformationItemEditInput
                                icon={<GiSolarPower />}
                                type={"float"}
                                id={`${currentInformationItem._id}photovoltaic`}
                                unit={"kWh"}
                                value={currentInformationItem.photovoltaic}
                                placeholder={"Zählerstand Photovoltaik"}
                            />
                            <InformationItemEditInput
                                icon={<FaRegCommentDots />}
                                type={"text"}
                                maxLength={99}
                                id={`${currentInformationItem._id}commentPhotovoltaic`}
                                value={currentInformationItem.commentPhotovoltaic}
                                placeholder={"Kommentar Photovoltaik"}
                            />
                        </div>
                        <div className='content-comment'>
                            <InformationItemInfo text={"Wasser:"} headline />
                        </div>
                        <div className='content-center'>
                            <InformationItemEditInput
                                icon={<GiWaterDrop />}
                                type={"float"}
                                id={`${currentInformationItem._id}water`}
                                unit={"m³"}
                                value={currentInformationItem.water}
                                placeholder={"Zählerstand Wasser"}
                            />
                            <InformationItemEditInput
                                icon={<FaRegCommentDots />}
                                type={"text"}
                                maxLength={99}
                                id={`${currentInformationItem._id}commentWater`}
                                value={currentInformationItem.commentWater}
                                placeholder={"Kommentar Wasser"}
                            />
                        </div>
                        <div className='content-comment'>
                            <InformationItemInfo text={"Heizung:"} headline />
                        </div>
                        <div className='content-center'>
                            <InformationItemEditInput
                                icon={<GiHeatHaze />}
                                type={"float"}
                                id={`${currentInformationItem._id}heating`}
                                unit={"kWh"}
                                value={currentInformationItem.heating}
                                placeholder={"Zählerstand Heizung"}
                            />
                            <InformationItemEditInput
                                icon={<FaRegCommentDots />}
                                type={"text"}
                                maxLength={99}
                                id={`${currentInformationItem._id}commentHeating`}
                                value={currentInformationItem.commentHeating}
                                placeholder={"Kommentar Heizung"}
                            />
                        </div>
                        <footer>
                            <div className='actions'>
                                <button
                                    className='btn edit-btn'
                                    type='submit'
                                >Speichern
                                </button>
                                <button
                                    type='button'
                                    className='btn delete-btn'
                                    onClick={() => {
                                        setLocalStateValues({ ...localStateValues, isEditing: false })
                                    }}>
                                    Abbrechen
                                </button>
                            </div>
                        </footer>
                    </div>
                </form>
                :
                <div className='content'>
                    {(currentInformationItem.electricity || currentInformationItem.electricity === 0) &&
                        <>
                            <div className='content-comment'>
                                <InformationItemInfo text={"Strom:"} headline />
                            </div>
                            <div className='content-center'>
                                <InformationItemInfo
                                    icon={<GiElectric />}
                                    text={currentInformationItem.electricity + " kWh"} />
                                <InformationItemInfo
                                    icon={<FaCalculator />}
                                    text={isPreviousMonthProvided ? consumptionElectricity + " kWh" : "Berechnung nicht möglich!"} />
                            </div>
                        </>
                    }
                    {currentInformationItem.commentElectricity && (currentInformationItem.electricity || currentInformationItem.electricity === 0) &&
                        <div className='content-comment'>
                            <InformationItemInfo icon={<FaRegCommentDots />} text={currentInformationItem.commentElectricity} />
                        </div>
                    }
                    {(currentInformationItem.photovoltaic || currentInformationItem.photovoltaic === 0) &&
                        <>
                            <div className='content-comment'>
                                <InformationItemInfo text={"Photovoltaik:"} headline />
                            </div>
                            <div className='content-center'>
                                <InformationItemInfo
                                    icon={<GiSolarPower />}
                                    text={currentInformationItem.photovoltaic + " kWh"} />
                                <InformationItemInfo
                                    icon={<FaCalculator />}
                                    text={isPreviousMonthProvided ? gainPhotovoltaic + " kWh" : "Berechnung nicht möglich!"} />
                            </div>
                        </>
                    }
                    {currentInformationItem.commentPhotovoltaic && (currentInformationItem.photovoltaic || currentInformationItem.photovoltaic === 0) &&
                        <div className='content-comment'>
                            <InformationItemInfo icon={<FaRegCommentDots />} text={currentInformationItem.commentPhotovoltaic} />
                        </div>
                    }
                    {(currentInformationItem.water || currentInformationItem.water === 0) &&
                        <>
                            <div className='content-comment'>
                                <InformationItemInfo text={"Wasser:"} headline />
                            </div>
                            <div className='content-center'>
                                <InformationItemInfo
                                    icon={<GiWaterDrop />}
                                    text={currentInformationItem.water + " m³"} />
                                <InformationItemInfo
                                    icon={<FaCalculator />}
                                    text={isPreviousMonthProvided ? consumptionWater + " m³" : "Berechnung nicht möglich!"} />
                            </div>
                        </>
                    }
                    {currentInformationItem.commentWater && (currentInformationItem.water || currentInformationItem.water === 0) &&
                        <div className='content-comment'>
                            <InformationItemInfo icon={<FaRegCommentDots />} text={currentInformationItem.commentWater} />
                        </div>
                    }
                    {(currentInformationItem.heating || currentInformationItem.heating === 0) &&
                        <>
                            <div className='content-comment'>
                                <InformationItemInfo text={"Heizung:"} headline />
                            </div>
                            <div className='content-center'>
                                <InformationItemInfo
                                    icon={<GiHeatHaze />}
                                    text={currentInformationItem.heating + " kWh"} />
                                <InformationItemInfo
                                    icon={<FaCalculator />}
                                    text={isPreviousMonthProvided ? consumptionHeating + " kWh" : "Berechnung nicht möglich!"} />
                            </div>
                        </>
                    }
                    {currentInformationItem.commentHeating && (currentInformationItem.heating || currentInformationItem.heating === 0) &&
                        <div className='content-comment'>
                            <InformationItemInfo icon={<FaRegCommentDots />} text={currentInformationItem.commentHeating} />
                        </div>
                    }
                    <footer>
                        <div className='actions'>
                            <button
                                className='btn edit-btn'
                                onClick={
                                    () => {
                                        setLocalStateValues({ ...localStateValues, isEditing: true })
                                    }}
                            >Bearbeiten
                            </button>
                            {/* <button
                                type='button'
                                className='btn delete-btn'
                                onClick={() => deleteInformationItem(currentInformationItem._id)}>
                                Löschen
                            </button> */}
                        </div>
                    </footer>
                </div>
            }
        </Wrapper>
    )
}

export default InformationItem;